import React, {Component, ReactNode} from 'react'
import {currentMedia} from '../../styledComponents/ResponsiveConvenience'
import styled from 'styled-components'
import {Colors} from '../../styledComponents/Constants'

interface Props {
    title?: string
    content: ReactNode
}

class ResidentSectionComponent extends Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render(): ReactNode {
        return <ResponsiveMarginArea>
            {this.props.title && <HeaderArea>
                {this.props.title}
            </HeaderArea>}
            <ContentArea>
                {this.props.content}
            </ContentArea>
        </ResponsiveMarginArea>
    }
}

export default ResidentSectionComponent

const ResponsiveMarginArea = styled.div`
  width: 100%;
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
`

const HeaderArea = styled.div`
  background-color: ${Colors.AccentLight};
  padding: 5px 15px;
  box-sizing: border-box;
`

const ContentArea = styled.div`
  background-color: ${Colors.Surface};
  padding: 20px 15px;
  box-sizing: border-box;
`
